/* global fetch */
import 'isomorphic-fetch'
import uuid from 'uuid/v4'
import jwtDecode from 'jwt-decode'
import { decamelizeKeys } from 'humps'
import { merge } from 'lodash'

import AliadaAnalyticsPersistence from './persistence'
import { getAuthToken } from 'utils/auth'
import * as utils from './utils'

export const DEFAULT_CONFIG = {
  debug: process.env.NODE_ENV !== 'production',
  host: 'https://aliada.mx/events/',
  storageName: 'aliada_analytics'
}

function AliadaAnalytics (config = {}) {
  if (!(this instanceof AliadaAnalytics)) {
    return new AliadaAnalytics(...arguments)
  }

  this.config = merge({}, DEFAULT_CONFIG, config)
  this.persistence = new AliadaAnalyticsPersistence(this.config)
  this._init()
}

const analytics = AliadaAnalytics.prototype

analytics._init = function () {
  const __getUserId = () => {
    try {
      const token = getAuthToken()
      const { user_id: userId } = jwtDecode(token)
      return userId
    } catch (e) {
      return
    }
  }

  const onceProps = {
    uniqueId: uuid()
  }

  const everytimeProps = {
    userId: __getUserId()
  }

  this.registerOnce(onceProps)
  this.register(everytimeProps)
}

analytics._sendRequest = function (data) {
  const { host } = this.config

  const body = typeof data === 'object'
    ? JSON.stringify(decamelizeKeys(data))
    : data

  const config = {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body
  }

  return fetch(host, config).then((response) => {
    return response.json().then((json) => ({json, response}))
  }).then(
    ({json, response}) => {
      if (!response.ok) {
        const { errors } = json
        const { status, statusText } = response

        const error = errors || `${status}: ${statusText}`
        return Promise.reject(error)
      }

      return json
    }
  )
}

analytics.track = function (eventName, eventProps = {}) {
  if (!eventName) {
    console.error('No event name provided to AliadaAnalytics.track')
    return
  }

  const generalProps = utils.getGeneralInfo()
  const registeredProps = this.persistence.properties()
  const finalProps = merge({}, generalProps, registeredProps, eventProps)

  const cleanFinalProps = utils.removeUndefinedProps(finalProps)
  const { uniqueId, userId } = cleanFinalProps

  const eventData = {
    name: eventName,
    emitterId: userId || uniqueId || 'UNKNOWN_USER',
    emitterType: userId ? 'User' : 'AnonymousUser',
    properties: cleanFinalProps
  }

  if (!this.config.debug) {
    this._sendRequest(eventData)
  }
}

analytics.registerOnce = function (props) {
  this.persistence.registerOnce(props)
}

analytics.register = function (props) {
  this.persistence.register(props)
}

analytics.reset = function () {
  this.persistence.clear()
  this._init()
}

export default AliadaAnalytics



// WEBPACK FOOTER //
// ./src/services/aliada-analytics/analytics.js